// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgOCA1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNC4yNjIwMSAzLjk5NDc3QzQuMTIxODUgNC4xMjczMSAzLjkzMTA2IDQuMjAxODYgMy43MzIwNCA0LjIwMTg2QzMuNTMzMDEgNC4yMDE4NiAzLjM0MjIyIDQuMTI3MzEgMy4yMDIwNyAzLjk5NDc3TDAuMjE2MzI1IDEuMTk0MjdDMC4wNzg0MjU0IDEuMDYzODYgMC4wMDA2ODMyNjYgMC44ODc4NTMgLTAuMDAwMTQxMTc3IDAuNzA0MTgzQy0wLjAwMTI4Nzk2IDAuNTE4MDg4IDAuMDc2NjAyNCAwLjMzOTIyMiAwLjIxNjMyNSAwLjIwNzA5NUMwLjM1NjQ4MSAwLjA3NDU1MjkgMC41NDcyNjcgLTIuODM3MTZlLTA3IDAuNzQ2Mjk0IC0yLjc1NTU2ZS0wN0MwLjk0NTMyMiAtMi42NzM5NmUtMDcgMS4xMzYxMSAwLjA3NDU1MjkgMS4yNzYyNiAwLjIwNzA5NUwzLjczMjA0IDIuNTEwNUw2LjE4NzgxIDAuMjIxMDk4QzYuMzc3MTUgMC4wNDM1MDU1IDYuNjUzMTIgLTAuMDI1ODUyMiA2LjkxMTc2IDAuMDM5MTUxMUM3LjE3MDQgMC4xMDQxNTQgNy4zNzI0MyAwLjI5MzY0MyA3LjQ0MTczIDAuNTM2MjM5QzcuNTExMDMgMC43Nzg4MzUgNy40MzcwOSAxLjAzNzY4IDcuMjQ3NzUgMS4yMTUyN0w0LjI2MjAxIDMuOTk0NzdaIiBmaWxsPSIjNkE4OTkxIi8+Cjwvc3ZnPgo=", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  border-collapse: collapse;
  border: 1px solid #DBE7F1;
}

tr {
  border-top: 1px solid #DBE7F1;
}

th {
  padding: 10px 20px 10px 10px;
  color: #6A8991;
  font-weight: 500;
  font-size: 14px;
  text-align: left;
}

td {
  background-color: white;
  font-size: 14px;
  padding: 10px 20px 10px 10px;
  font-weight: 500;
}

.link18 {
  color: blue;
  text-decoration: underline;
  font-size: 14px;
}

.font2, .ReactTags__tagInput input.ReactTags__tagInputField,
.ReactTags__tagInput input.ReactTags__tagInputField:focus, .ReactTags__tag, option {
  font-family: "Inter";
}

.fontSize10 {
  font-size: 10px;
}

.fontSize11 {
  font-size: 11px;
}

.fontSize12 {
  font-size: 12px;
}

.fontSize13 {
  font-size: 13px;
}

.fontSize14, .ReactTags__selected span.ReactTags__tag, .ReactTags__tagInput input.ReactTags__tagInputField,
.ReactTags__tagInput input.ReactTags__tagInputField:focus, .ReactTags__tag {
  font-size: 14px;
}

.fontSize15 {
  font-size: 15px;
}

#outer-container {
  background-color: #F7FAFC;
}

.errorText {
  padding: 5px;
  font-size: 14px;
  color: red;
}

input[type=radio] {
  margin-top: -1px;
}

body {
  font-family: "Inter";
  background-color: #F5F9FF;
  margin: 0;
  padding: 0;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
}

a, a:visited {
  color: #30A9B8;
  text-decoration: none;
}

.extended-table-row-container {
  display: flex;
  background: #113045;
  padding: 20px;
  border: 1px solid #0c424b;
  border-left-width: 0;
  border-right-width: 0;
  min-height: 150px;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: #d0dbe4;
  scrollbar-width: thin;
  scrollbar-gutter: stable;
}

::-webkit-scrollbar-thumb {
  background-color: #c0cedc;
  border-radius: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f6f2f2;
}

.container {
  margin: auto;
  width: 50%;
}

.ReactTags__tags {
  position: relative;
  display: flex;
  align-items: flex-start;
}

.timepicker, .timePicker {
  width: 60px !important;
  text-align: center;
}

select, video {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.flexRow {
  display: flex;
  align-items: center;
}

/* Styles for the input */
.ReactTags__tagInput {
  width: 270px;
  border-radius: 2px;
  display: inline-block;
}

.react-tags-wrapper {
  width: 90%;
  box-sizing: border-box;
  border: 1px solid #c3c8ca;
  outline: none;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.popup-footer {
  height: 50px;
  background-color: #eee;
  border-top: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px;
}

.ReactTags__tagInput input.ReactTags__tagInputField,
.ReactTags__tagInput input.ReactTags__tagInputField:focus {
  height: 31px;
  margin: 0;
  width: 100%;
  border: 0;
  padding-bottom: 2px;
  padding-left: 10px;
  outline: none;
}

/* Styles for selected tags */
.ReactTags__selected {
  outline: none;
  max-width: 500px;
}

.ReactTags__selected span.ReactTags__tag {
  border: 1px solid #ddd;
  background: #eee;
  display: inline-block;
  padding: 5px;
  margin: 3px 5px;
  border-radius: 2px;
}

.ReactTags__selected a.ReactTags__remove {
  color: #aaa;
  margin-left: 5px;
  cursor: pointer;
}

/* Styles for suggestions */
.ReactTags__suggestions {
  position: absolute;
}

.ReactTags__suggestions ul {
  list-style-type: none;
  box-shadow: 0.05em 0.01em 0.5em rgba(0, 0, 0, 0.2);
  background: white;
  width: 200px;
}

.ReactTags__suggestions li {
  border-bottom: 1px solid #ddd;
  padding: 5px 10px;
  margin: 0;
}

.ReactTags__suggestions li mark {
  text-decoration: underline;
  background: none;
  font-weight: 600;
}

.ReactTags__suggestions ul li.ReactTags__activeSuggestion {
  background: #b7cfe0;
  cursor: pointer;
}

.ReactTags__remove {
  border: none;
  cursor: pointer;
  background: none;
}

.tag {
  background-color: #EFF6F8;
  border: 1px solid #B9BEC0;
  border-radius: 4px;
  height: 30px;
  display: flex;
  align-items: center;
  padding: 0 5px;
  margin-right: 10px;
}

.tag:hover {
  color: white !important;
  background-color: black !important;
}

.react-confirm-alert-overlay {
  z-index: 9999;
}

.checkbox-primary {
  width: 16px;
  height: 16px;
  border-radius: 2px;
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid #40A0C1;
  background-color: #FFFFFF;
  position: relative;
  cursor: pointer;
}

.checkbox-primary:checked {
  background-color: #40A0C1;
}

.checkbox-primary:checked::before {
  content: "";
  position: absolute;
  display: block;
  left: 4.5px;
  top: 0.5px;
  width: 3px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.select-primary {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid #D3E1ED;
  border-radius: 5px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 10px;
}

.radio-primary {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  appearance: none;
  -webkit-appearance: none;
  background-color: #D3E1ED;
  position: relative;
  cursor: pointer;
}

.radio-primary:checked {
  background-color: #40A0C1;
}

.popup-overlay {
  outline: none;
  background-color: rgba(0, 0, 0, 0.5);
}

.popupContainer {
  background: #FFFFFF;
  border-radius: 10px;
  box-shadow: 0px 9px 25px rgba(129, 155, 163, 0.27);
  padding: 25px 29px;
  position: relative;
  padding: 0;
  background-color: #FFFFFF;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow: hidden;
  animation: popupSlideIn 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.popupContainer.legacy-style {
  border: 1px solid #C3C8CA;
  background-color: #F7FAFC;
  box-shadow: 1px 2px 0 0 rgba(40, 39, 40, 0.2);
  border-radius: 5px;
  min-width: 500px;
  min-height: 300px;
}

.titleRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #FFFFFF;
  padding: 25px 29px;
  padding-bottom: 0;
  border-bottom: none;
  flex-shrink: 0;
  position: relative;
  border-radius: 10px;
}
.titleRow .popup-close-btn {
  position: absolute;
  top: 18px;
  right: 18px;
  width: 12px;
  height: 12px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.titleRow .popup-close-btn svg, .titleRow .popup-close-btn .icon {
  width: 12px;
  height: 12px;
  color: rgba(0, 0, 0, 0.85);
}
.titleRow .popup-close-btn:hover {
  opacity: 0.7;
}
.titleRow .popup-close-btn svg, .titleRow .popup-close-btn span {
  width: 12px;
  height: 12px;
  color: rgba(0, 0, 0, 0.85);
  display: block;
}

.title {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.21em;
  color: #142A31;
  margin: 0 0 20px 0;
  display: flex;
  align-items: baseline;
  padding-left: 0;
  -webkit-font-smoothing: antialiased;
}

.subtitle {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.21em;
  color: #142A31;
  padding-left: 10px;
  color: #142B31;
  opacity: 0.8;
  font-size: 16px;
  font-weight: 500;
}

.contentContainer {
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.21em;
  color: #142A31;
  padding: 20px 29px;
  padding-bottom: 29px;
  overflow-y: auto;
  flex-grow: 1;
}
.contentContainer > *:first-child {
  margin-top: 0;
}
.contentContainer > *:last-child {
  margin-bottom: 0;
}

@keyframes popupSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.popupFooter {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  padding: 25px 29px;
  padding-top: 20px;
  background: #FFFFFF;
  flex-shrink: 0;
  border-radius: 10px;
}

@media (max-width: 480px) {
  .popupContainer {
    width: calc(100vw - 40px);
    margin: 20px;
  }
  .titleRow {
    padding: 15px 20px;
    padding-bottom: 0;
  }
  .contentContainer {
    padding: 15px 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/components/PopupWin/popupWin.scss","webpack://./src/styles/popup-design-system.scss"],"names":[],"mappings":"AAkCA;EACC,yBAAA;EACA,yBAAA;ACjCD;;ADoCA;EACC,6BAAA;ACjCD;;ADoCA;EACC,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;ACjCD;;ADoCA;EACC,uBAAA;EACA,eAAA;EACA,4BAAA;EACA,gBAAA;ACjCD;;ADoCA;EACC,WAAA;EACA,0BAAA;EACA,eAAA;ACjCD;;ADoCA;;EACC,oBAAA;AChCD;;ADmCA;EACC,eAAA;AChCD;;ADmCA;EACC,eAAA;AChCD;;ADmCA;EACC,eAAA;AChCD;;ADmCA;EACC,eAAA;AChCD;;ADmCA;;EACC,eAAA;AC/BD;;ADkCA;EACC,eAAA;AC/BD;;ADkCA;EACC,yBAnFO;ACoDR;;ADkCA;EACC,YAAA;EACA,eAAA;EACA,UAAA;AC/BD;;ADkCA;EACC,gBAAA;AC/BD;;ADkCA;EACC,oBAAA;EACA,yBAAA;EACA,SAAA;EACA,UAAA;AC/BD;;ADkCA;EACC,+EAAA;AC/BD;;ADmCA;EACC,cAAA;EACA,qBAAA;AChCD;;ADuCA;EACC,aAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,oBAAA;EACA,qBAAA;EACA,iBAAA;ACpCD;;ADoDA;EACC,UAAA;EACA,WAAA;EACA,yBAAA;EACA,qBAAA;EACA,wBAAA;ACjDD;;ADoDA;EACC,yBAAA;EACA,kBAAA;ACjDD;;ADoDA;EACC,yBAAA;ACjDD;;ADqDA;EACC,YAAA;EACA,UAAA;AClDD;;ADyDA;EACC,kBAAA;EACA,aAAA;EACA,uBAAA;ACtDD;;ADyDA;EACC,sBAAA;EACA,kBAAA;ACtDD;;ADyDA;EACC,oCAAA;UAAA,4BAAA;ACtDD;;ADyDA;EACC,aAAA;EACA,mBAAA;ACtDD;;ADyDA,yBAAA;AACA;EACC,YAAA;EACA,kBAAA;EACA,qBAAA;ACtDD;;ADyDA;EACC,UAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;ACtDD;;ADyDA;EACC,YAAA;EACA,sBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;ACtDD;;ADyDA;;EAIC,YAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;ACxDD;;AD2DA,6BAAA;AACA;EACC,aAAA;EACA,gBAAA;ACxDD;;AD2DA;EAEC,sBAAA;EACA,gBAAA;EACA,qBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;ACzDD;;AD2DA;EACC,WAAA;EACA,gBAAA;EACA,eAAA;ACxDD;;AD2DA,2BAAA;AACA;EACC,kBAAA;ACxDD;;AD0DA;EACC,qBAAA;EACA,kDAAA;EACA,iBAAA;EACA,YAAA;ACvDD;;ADyDA;EACC,6BAAA;EACA,iBAAA;EACA,SAAA;ACtDD;;ADwDA;EACC,0BAAA;EACA,gBAAA;EACA,gBAAA;ACrDD;;ADuDA;EACC,mBAAA;EACA,eAAA;ACpDD;;ADuDA;EACC,YAAA;EACA,eAAA;EACA,gBAAA;ACpDD;;ADuDA;EACC,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;ACpDD;;ADuDA;EACC,uBAAA;EACA,kCAAA;ACpDD;;ADuDA;EACC,aAAA;ACpDD;;ADuDA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;ACpDD;;ADuDA;EACE,yBAAA;ACpDF;;ADwDA;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;ACrDD;;ADwDA;EACC,gBAAA;EACC,wBAAA;EACA,qBAAA;EAED,yBAAA;EACA,kBAAA;EACC,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;ACtDF;;ADyDA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;ACtDD;;ADyDA;EACE,yBAAA;ACtDF;;AAnTA;EACC,aAAA;EACA,oCAAA;AAsTD;;AAnTA;ECwHE,mBAAA;EACA,mBAAA;EACA,kDAAA;EACA,kBAAA;EACA,kBAAA;ED1HD,UAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yDAAA;AA0TD;AAvTC;EACC,yBAAA;EACA,yBDXM;ECYN,6CAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAyTF;;AArTA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAwTD;AArTC;ECiLC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qDAAA;ADuIF;ACrIE;EACE,WAAA;EACA,YAAA;EACA,0BAAA;ADuIJ;ACpIE;EACE,YAAA;ADsIJ;AAzUE;EACC,WAAA;EACA,YAAA;EACA,0BAAA;EACA,cAAA;AA2UH;;AAtUA;ECkFE,yFAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EDrFD,aAAA;EACA,qBAAA;EACA,eAAA;EACA,mCAAA;AA8UD;;AA3UA;ECoFE,yFAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EDtFD,kBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AAkVD;;AA/UA;EC2EE,yFAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;ED7ED,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,YAAA;AAsVD;AAnVC;EACC,aAAA;AAqVF;AAlVC;EACC,gBAAA;AAoVF;;AA/UA;EACC;IACC,UAAA;IACA,4BAAA;EAkVA;EAhVD;IACC,UAAA;IACA,wBAAA;EAkVA;AACF;AA9UA;EACC,aAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AAgVD;;AA5UA;EACC;IACC,yBAAA;IACA,YAAA;EA+UA;EA5UD;IACC,kBAAA;IACA,iBAAA;EA8UA;EA3UD;IACC,kBAAA;EA6UA;AACF","sourcesContent":["// Import the new popup design system\n@import './styles/popup-design-system.scss';\n\n$mobile:  \"(max-width: 765px)\";\n$tablet:  \"(min-width: 766px) and (max-width: 1023px)\";\n$desktop: \"(min-width: 1024px)\";\n\n\n$link: #465bab;\n$menuBg: #071623;\n$appBg: #F7FAFC;\n$mainBg: #F8FAFC;\n$mainTitle: #000000;\n$appBlue: #4070AE;\n$appGreen: #8AC93D;\n$appYellow: #feee96;\n$lightGreen: #AAFFAA;\n$lightBlue: #a5f2ff;\n$glowingBlue: #15d5f7;\n$glowingGreen: #00ffc7;\n$headerIcons: #ffffff;\n$buttonGreen: #8AC93D;\n$appDisabled: #dddddd;\n$lightText: #ddf3f6;\n$disabledText: #455465;\n$webPageBg: #1a4d73d1;\n$transparent: transparent;\n\n$headerHeight: 80px;\n$pageTitleHeight: 80px;\n\n* {\n}\n\ntable {\n\tborder-collapse:collapse;\n\tborder: 1px solid #DBE7F1;\n}\n\ntr {\n\tborder-top: 1px solid #DBE7F1;\n}\n\nth {\n\tpadding: 10px 20px 10px 10px;\n\tcolor: #6A8991;\n\tfont-weight: 500;\n\tfont-size: 14px;\n\ttext-align: left;\n}\n\ntd {\n\tbackground-color: white;\n\tfont-size: 14px;\n\tpadding: 10px 20px 10px 10px;\n\tfont-weight: 500;\n}\n\n.link18 {\n\tcolor: blue;\n\ttext-decoration: underline;\n\tfont-size: 14px;\n}\n\n.font2 {\n\tfont-family: 'Inter';\n}\n\n.fontSize10 {\n\tfont-size: 10px;\n}\n\n.fontSize11 {\n\tfont-size: 11px;\n}\n\n.fontSize12 {\n\tfont-size: 12px;\n}\n\n.fontSize13 {\n\tfont-size: 13px;\n}\n\n.fontSize14 {\n\tfont-size: 14px;\n}\n\n.fontSize15 {\n\tfont-size: 15px;\n}\n\n#outer-container {\n\tbackground-color: $appBg;\n}\n\n.errorText {\n\tpadding: 5px;\n\tfont-size: 14px;\n\tcolor: red;\n}\n\ninput[type=\"radio\"] {\n\tmargin-top: -1px;\n}\n\nbody {\n\tfont-family: 'Inter';\n\tbackground-color: #F5F9FF;\n\tmargin: 0;\n\tpadding: 0;\n}\n\ncode {\n\tfont-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n\tmonospace;\n}\n\na, a:visited {\n\tcolor: #30A9B8;\n\ttext-decoration: none;\n}\n\noption {\n\t@extend .font2;\n}\n\n.extended-table-row-container {\n\tdisplay: flex;\n\tbackground: #113045;\n\tpadding: 20px;\n\tborder: 1px solid #0c424b;\n\tborder-left-width: 0;\n\tborder-right-width: 0;\n\tmin-height: 150px;\n}\n\n// body::-webkit-scrollbar {\n// \twidth: 10px;\n// }\n\n// body::-webkit-scrollbar-track {\n// \tbox-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n// }\n\n// body::-webkit-scrollbar-thumb {\n// \tbackground-color: $glowingGreen;\n// \toutline: 1px solid slategrey;\n// }\n\n::-webkit-scrollbar {\n\twidth: 8px;\n\theight: 8px;\n\tbackground-color: #d0dbe4;\n\tscrollbar-width: thin;\n\tscrollbar-gutter: stable;\n}\n\n::-webkit-scrollbar-thumb {\n\tbackground-color: #c0cedc;\n\tborder-radius: 6px;\n}\n\n::-webkit-scrollbar-track {\n\tbackground-color: #f6f2f2;\n}\n\n\n.container {\n\tmargin: auto;\n\twidth: 50%;\n}\n.ReactTags__tag {\n\t@extend .font2;\n\t@extend .fontSize14;\n}\n\n.ReactTags__tags {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: flex-start;\n}\n\n.timepicker, .timePicker {\n\twidth: 60px !important;\n\ttext-align: center;\n}\n\nselect, video {\n\tuser-select: none !important;\n}\n\n.flexRow {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n/* Styles for the input */\n.ReactTags__tagInput {\n\twidth: 270px;\n\tborder-radius: 2px;\n\tdisplay: inline-block;\n}\n\n.react-tags-wrapper {\n\twidth: 90%;\n\tbox-sizing: border-box;\n\tborder: 1px solid #c3c8ca;\n\toutline: none;\n\tborder-radius: 5px;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.popup-footer {\n\theight: 50px;\n\tbackground-color: #eee;\n\tborder-top: 1px solid #ddd;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tpadding: 0 20px;\n}\n\n.ReactTags__tagInput input.ReactTags__tagInputField,\n.ReactTags__tagInput input.ReactTags__tagInputField:focus {\n\t@extend .font2;\n\t@extend .fontSize14;\n\theight: 31px;\n\tmargin: 0;\n\twidth: 100%;\n\tborder: 0;\n\tpadding-bottom: 2px;\n\tpadding-left: 10px;\n\toutline: none;\n}\n\n/* Styles for selected tags */\n.ReactTags__selected {\n\toutline: none;\n\tmax-width: 500px;\n}\n\n.ReactTags__selected span.ReactTags__tag {\n\t@extend .fontSize14;\n\tborder: 1px solid #ddd;\n\tbackground: #eee;\n\tdisplay: inline-block;\n\tpadding: 5px;\n\tmargin: 3px 5px;\n\tborder-radius: 2px;\n}\n.ReactTags__selected a.ReactTags__remove {\n\tcolor: #aaa;\n\tmargin-left: 5px;\n\tcursor: pointer;\n}\n\n/* Styles for suggestions */\n.ReactTags__suggestions {\n\tposition: absolute;\n}\n.ReactTags__suggestions ul {\n\tlist-style-type: none;\n\tbox-shadow: .05em .01em .5em rgba(0,0,0,.2);\n\tbackground: white;\n\twidth: 200px;\n}\n.ReactTags__suggestions li {\n\tborder-bottom: 1px solid #ddd;\n\tpadding: 5px 10px;\n\tmargin: 0;\n}\n.ReactTags__suggestions li mark {\n\ttext-decoration: underline;\n\tbackground: none;\n\tfont-weight: 600;\n}\n.ReactTags__suggestions ul li.ReactTags__activeSuggestion {\n\tbackground: #b7cfe0;\n\tcursor: pointer;\n}\n\n.ReactTags__remove {\n\tborder: none;\n\tcursor: pointer;\n\tbackground: none;\n}\n\n.tag {\n\tbackground-color: #EFF6F8;\n\tborder: 1px solid #B9BEC0;\n\tborder-radius: 4px;\n\theight: 30px;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0 5px;\n\tmargin-right: 10px;\n}\n\n.tag:hover {\n\tcolor: white !important;\n\tbackground-color: black !important;\n}\n\n.react-confirm-alert-overlay {\n\tz-index: 9999;\n}\n\n.checkbox-primary {\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 2px;\n\tappearance: none;\n\t-webkit-appearance: none;\n\tborder: 1px solid #40A0C1;\n\tbackground-color: #FFFFFF;\n\tposition: relative;\n\tcursor: pointer;\n}\n\n.checkbox-primary:checked {\n  background-color: #40A0C1;\n}\n\n\n.checkbox-primary:checked::before {\n\tcontent: \"\";\n\tposition: absolute;\n\tdisplay: block;\n\tleft: 4.5px;\n\ttop: 0.5px;\n\twidth: 3px;\n\theight: 8px;\n\tborder: solid white;\n\tborder-width: 0 2px 2px 0;\n\ttransform: rotate(45deg);\n}\n\n.select-primary {\n\tappearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n\n\tborder: 1px solid #D3E1ED;\n\tborder-radius: 5px;\n  background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgOCA1IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNC4yNjIwMSAzLjk5NDc3QzQuMTIxODUgNC4xMjczMSAzLjkzMTA2IDQuMjAxODYgMy43MzIwNCA0LjIwMTg2QzMuNTMzMDEgNC4yMDE4NiAzLjM0MjIyIDQuMTI3MzEgMy4yMDIwNyAzLjk5NDc3TDAuMjE2MzI1IDEuMTk0MjdDMC4wNzg0MjU0IDEuMDYzODYgMC4wMDA2ODMyNjYgMC44ODc4NTMgLTAuMDAwMTQxMTc3IDAuNzA0MTgzQy0wLjAwMTI4Nzk2IDAuNTE4MDg4IDAuMDc2NjAyNCAwLjMzOTIyMiAwLjIxNjMyNSAwLjIwNzA5NUMwLjM1NjQ4MSAwLjA3NDU1MjkgMC41NDcyNjcgLTIuODM3MTZlLTA3IDAuNzQ2Mjk0IC0yLjc1NTU2ZS0wN0MwLjk0NTMyMiAtMi42NzM5NmUtMDcgMS4xMzYxMSAwLjA3NDU1MjkgMS4yNzYyNiAwLjIwNzA5NUwzLjczMjA0IDIuNTEwNUw2LjE4NzgxIDAuMjIxMDk4QzYuMzc3MTUgMC4wNDM1MDU1IDYuNjUzMTIgLTAuMDI1ODUyMiA2LjkxMTc2IDAuMDM5MTUxMUM3LjE3MDQgMC4xMDQxNTQgNy4zNzI0MyAwLjI5MzY0MyA3LjQ0MTczIDAuNTM2MjM5QzcuNTExMDMgMC43Nzg4MzUgNy40MzcwOSAxLjAzNzY4IDcuMjQ3NzUgMS4yMTUyN0w0LjI2MjAxIDMuOTk0NzdaIiBmaWxsPSIjNkE4OTkxIi8+Cjwvc3ZnPgo=');\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 10px;\n}\n\n.radio-primary {\n\twidth: 16px;\n\theight: 16px;\n\tborder-radius: 50%;\n\tappearance: none;\n\t-webkit-appearance: none;\n\tbackground-color: #D3E1ED;\n\tposition: relative;\n\tcursor: pointer;\n}\n\n.radio-primary:checked {\n  background-color: #40A0C1;\n}","@import \"../../index\";\n@import '../../styles/popup-design-system.scss';\n\n.popup-overlay {\n\toutline: none;\n\tbackground-color: popup-color('bg-overlay');\n}\n\n.popupContainer {\n\t@include popup-container;\n\tpadding: 0; // Override mixin padding for custom layout\n\tbackground-color: popup-color('bg-primary');\n\tdisplay: flex;\n\tflex-direction: column;\n\tmax-height: 80vh;\n\toverflow: hidden;\n\tanimation: popupSlideIn popup-effect('transition-duration') popup-effect('transition-ease');\n\n\t// Maintain backward compatibility\n\t&.legacy-style {\n\t\tborder: 1px solid #C3C8CA;\n\t\tbackground-color: $appBg;\n\t\tbox-shadow: 1px 2px 0 0 rgba(40,39,40,0.2);\n\t\tborder-radius: 5px;\n\t\tmin-width: 500px;\n\t\tmin-height: 300px;\n\t}\n}\n\n.titleRow {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbackground-color: popup-color('bg-primary');\n\tpadding: popup-dim('padding-vertical') popup-dim('padding-container');\n\tpadding-bottom: 0;\n\tborder-bottom: none; // Remove old border\n\tflex-shrink: 0;\n\tposition: relative;\n\tborder-radius: 10px;\n\n\t// Close button styling\n\t.popup-close-btn {\n\t\t@include popup-close-button;\n\n\t\t// Icon styling\n\t\tsvg, span {\n\t\t\twidth: popup-dim('close-btn-size');\n\t\t\theight: popup-dim('close-btn-size');\n\t\t\tcolor: popup-color('icon-close');\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n\n.title {\n\t@include popup-title;\n\tdisplay: flex;\n\talign-items: baseline;\n\tpadding-left: 0; // Remove old padding\n\t-webkit-font-smoothing: antialiased;\n}\n\n.subtitle {\n\t@include popup-body;\n\tpadding-left: 10px;\n\tcolor: popup-color('text-secondary');\n\topacity: 0.8;\n\tfont-size: popup-typo('subtitle-size');\n\tfont-weight: popup-typo('subtitle-weight');\n}\n\n.contentContainer {\n\t@include popup-body;\n\tpadding: 20px popup-dim('padding-container');\n\tpadding-bottom: popup-dim('padding-container');\n\toverflow-y: auto;\n\tflex-grow: 1;\n\n\t// Ensure proper spacing for content\n\t> *:first-child {\n\t\tmargin-top: 0;\n\t}\n\n\t> *:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\n\n// Animation for popup entrance\n@keyframes popupSlideIn {\n\tfrom {\n\t\topacity: 0;\n\t\ttransform: translateY(-20px);\n\t}\n\tto {\n\t\topacity: 1;\n\t\ttransform: translateY(0);\n\t}\n}\n\n// Footer section for action buttons\n.popupFooter {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n\tgap: popup-dim('btn-gap');\n\tpadding: 25px popup-dim('padding-container');\n\tpadding-top: 20px;\n\tbackground: popup-color('bg-primary');\n\tflex-shrink: 0;\n\tborder-radius: 10px;\n}\n\n// Responsive adjustments\n@media (max-width: 480px) {\n\t.popupContainer {\n\t\twidth: calc(100vw - 40px);\n\t\tmargin: 20px;\n\t}\n\n\t.titleRow {\n\t\tpadding: 15px 20px;\n\t\tpadding-bottom: 0;\n\t}\n\n\t.contentContainer {\n\t\tpadding: 15px 20px;\n\t}\n}\n","// ===========================\n// CONNACT Popup Design System\n// Based on Figma Design\n// ===========================\n\n// Color Palette\n// -------------\n$popup-colors: (\n  // Backgrounds\n  'bg-primary': #FFFFFF,\n  'bg-overlay': rgba(0, 0, 0, 0.5),\n\n  // Text Colors\n  'text-primary': #142A31,\n  'text-secondary': #142B31,\n  'text-white': #FFFFFF,\n\n  // Button Colors\n  'btn-primary': #40A0C1,\n  'btn-secondary': #142B31,\n  'btn-danger': #FF5555,\n  'btn-success': #28A745,\n\n  // Icon Colors\n  'icon-close': rgba(0, 0, 0, 0.85),\n\n  // Shadow\n  'shadow': rgba(129, 155, 163, 0.27)\n);\n\n// Typography\n// ----------\n$popup-typography: (\n  // Font Family\n  'font-family': ('Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif),\n\n  // Title\n  'title-size': 22px,\n  'title-weight': 700,\n  'title-line-height': 1.21em,\n\n  // Subtitle\n  'subtitle-size': 16px,\n  'subtitle-weight': 500,\n  'subtitle-line-height': 1.25em,\n\n  // Body Text\n  'body-size': 14px,\n  'body-weight': 400,\n  'body-line-height': 1.21em,\n\n  // Button Text\n  'btn-size': 14px,\n  'btn-weight': 700,\n  'btn-line-height': 1.21em\n);\n\n// Dimensions & Spacing\n// -------------------\n$popup-dimensions: (\n  // Container\n  'border-radius': 10px,\n\n  // Padding\n  'padding-container': 29px,\n  'padding-vertical': 25px,\n\n  // Close Button\n  'close-btn-size': 12px,\n  'close-btn-offset': 18px,\n\n  // Buttons\n  'btn-height': 33px,\n  'btn-min-width': 79px,\n  'btn-max-width': 142px,\n  'btn-border-radius': 45px,\n  'btn-padding-h': 20px,\n  'btn-gap': 15px,\n\n  // Spacing\n  'title-margin-bottom': 20px,\n  'content-margin-bottom': 30px,\n  'footer-margin-top': 30px\n);\n\n// Effects\n// -------\n$popup-effects: (\n  'box-shadow': 0px 9px 25px map-get($popup-colors, 'shadow'),\n  'transition-duration': 0.2s,\n  'transition-ease': cubic-bezier(0.4, 0, 0.2, 1)\n);\n\n// Z-index layers\n// --------------\n$popup-z-index: (\n  'overlay': 9998,\n  'container': 9999,\n  'close-btn': 10000\n);\n\n// Utility Functions\n// ----------------\n@function popup-color($key) {\n  @return map-get($popup-colors, $key);\n}\n\n@function popup-typo($key) {\n  @return map-get($popup-typography, $key);\n}\n\n@function popup-dim($key) {\n  @return map-get($popup-dimensions, $key);\n}\n\n@function popup-effect($key) {\n  @return map-get($popup-effects, $key);\n}\n\n@function popup-z($key) {\n  @return map-get($popup-z-index, $key);\n}\n\n// Mixins\n// ------\n\n// Popup Container\n@mixin popup-container {\n  background: popup-color('bg-primary');\n  border-radius: popup-dim('border-radius');\n  box-shadow: popup-effect('box-shadow');\n  padding: popup-dim('padding-vertical') popup-dim('padding-container');\n  position: relative;\n}\n\n// Popup Title\n@mixin popup-title {\n  font-family: popup-typo('font-family');\n  font-size: popup-typo('title-size');\n  font-weight: popup-typo('title-weight');\n  line-height: popup-typo('title-line-height');\n  color: popup-color('text-primary');\n  margin: 0 0 popup-dim('title-margin-bottom') 0;\n}\n\n// Popup Body Text\n@mixin popup-body {\n  font-family: popup-typo('font-family');\n  font-size: popup-typo('body-size');\n  font-weight: popup-typo('body-weight');\n  line-height: popup-typo('body-line-height');\n  color: popup-color('text-primary');\n}\n\n// Button Base\n@mixin popup-button-base {\n  font-family: popup-typo('font-family');\n  font-size: popup-typo('btn-size');\n  font-weight: popup-typo('btn-weight');\n  line-height: popup-typo('btn-line-height');\n  height: popup-dim('btn-height');\n  min-width: popup-dim('btn-min-width');\n  padding: 0 popup-dim('btn-padding-h');\n  border-radius: popup-dim('btn-border-radius');\n  border: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: all popup-effect('transition-duration') popup-effect('transition-ease');\n\n  &:hover {\n    opacity: 0.9;\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n\n  &:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    transform: none;\n  }\n}\n\n// Button Variants\n@mixin popup-button-primary {\n  @include popup-button-base;\n  background-color: popup-color('btn-primary');\n  color: popup-color('text-white');\n\n  &:hover:not(:disabled) {\n    background-color: darken(popup-color('btn-primary'), 5%);\n  }\n}\n\n@mixin popup-button-secondary {\n  @include popup-button-base;\n  background-color: popup-color('btn-secondary');\n  color: popup-color('text-white');\n\n  &:hover:not(:disabled) {\n    background-color: lighten(popup-color('btn-secondary'), 10%);\n  }\n}\n\n@mixin popup-button-danger {\n  @include popup-button-base;\n  background-color: popup-color('btn-danger');\n  color: popup-color('text-white');\n\n  &:hover:not(:disabled) {\n    background-color: darken(popup-color('btn-danger'), 5%);\n  }\n}\n\n// Close Button\n@mixin popup-close-button {\n  position: absolute;\n  top: popup-dim('close-btn-offset');\n  right: popup-dim('close-btn-offset');\n  width: popup-dim('close-btn-size');\n  height: popup-dim('close-btn-size');\n  padding: 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  z-index: popup-z('close-btn');\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity popup-effect('transition-duration') popup-effect('transition-ease');\n\n  svg, .icon {\n    width: popup-dim('close-btn-size');\n    height: popup-dim('close-btn-size');\n    color: popup-color('icon-close');\n  }\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n// Overlay\n@mixin popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: popup-color('bg-overlay');\n  z-index: popup-z('overlay');\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n// Button Group\n@mixin popup-button-group {\n  display: flex;\n  gap: popup-dim('btn-gap');\n  justify-content: flex-end;\n  margin-top: popup-dim('footer-margin-top');\n}\n\n// Fixed Button Group (sticky at bottom)\n@mixin popup-button-group-fixed {\n  display: flex;\n  gap: popup-dim('btn-gap');\n  justify-content: flex-end;\n  padding: popup-dim('padding-vertical') popup-dim('padding-container');\n  padding-top: 20px;\n  background: popup-color('bg-primary');\n  border-top: 1px solid #e0e0e0;\n  position: sticky;\n  bottom: 0;\n  z-index: 10;\n}\n\n// Responsive adjustments\n@media (max-width: 480px) {\n  $popup-dimensions: map-merge($popup-dimensions, (\n    'padding-container': 20px\n  ));\n\n  @mixin popup-button-group {\n    flex-direction: column;\n    gap: 10px;\n\n    button {\n      width: 100%;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
